export const estraiDatiUtente = [
  '',
  `
  query estraiDatiUtente($email: String!){
    estraiDatiUtente(email: $email)
  }
  `,
  'estraiDatiUtente'];
